module.exports = __webpack_public_path__ + "img/placeholder.81962e0.svg";